import { combineReducers } from 'redux'
import attachments from '../../reducers/attachments'
import auctions from './auctions'
import bids from '../../reducers/bids'
import categories from '../../reducers/categories'
import config from '../../reducers/config'
import countries from '../../reducers/countries'
import invoices from '../../reducers/invoices'
// import lots from '../../reducers/lots'
import listingSales from './listingSales'
import maxBids from '../../reducers/maxBids'
import mediaFeed from '../../reducers/mediaFeed'
import notifications from '../../reducers/notifications'
import offers from '../../reducers/offers'
import orders from '../../reducers/orders'
import registrations from '../../reducers/registrations'
import sales from '../../reducers/sales'
import saleStatuses from '../../reducers/saleStatuses'
import saleSummaries from '../../reducers/saleSummaries'
import users from './users'
import webcast from '../../reducers/webcast'
// import increments from './increments'
import creditLimit from './creditLimit'
import lots from './lots'

export default combineReducers({
  auctions,
  bids,
  categories,
  config,
  countries,
  attachments,
  invoices,
  lots,
  listingSales,
  maxBids,
  mediaFeed,
  notifications,
  offers,
  orders,
  registrations,
  sales,
  saleStatuses,
  saleSummaries,
  users,
  webcast,
  // increments,
  creditLimit
})
